<template lang="pug">
component(:is="level" :class="headingClasses")
  span(v-if="content") {{ content }}
  slot(v-else)
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRogue } from '../../js/rogue'

const props = withDefaults(defineProps<{
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  text?: string
  align?: 'left' | 'center' | 'right'
  underline?: boolean
  titlecase?: boolean
  container?: string
  theme?: string | null
  font?: 'robotoHeader' | 'industry' | 'condensed' | 'invitational'
}>(), {
  level     : 'h2',
  text      : '',
  align     : 'left',
  underline : false,
  titlecase : false,
  container : 'none',
  theme     : null,
  font      : 'robotoHeader',
})

const rogue = useRogue()

const headingClasses = computed<Record<string, boolean>>(() => {
  return {
    underline                             : props.underline,
    titlecase                             : props.titlecase,
    [props.align]                         : props.align !== 'left',
    [props.font]                          : !!props.font,
    [props.theme as string]               : !!props.theme,
    [`main-container-${props.container}`] : props.container !== 'none',
  }
})

const content = computed<string>(() => props.text ? rogue.__(props.text, 'auto') : '')
</script>
<style lang="scss" scoped>
.section-header {
  color: $color-black;
  font-size: $size-xs;
  background-color: $color-gray-x-light;
  margin: 0;
  padding: $space-xs $space-s;

  &.dark {
    background-color: $color-black;
    color: $color-white;
  }
}

.industry {
  font-family: $font-industry;
}

.roboto-header {
  font-family: $font-header;
}

.condensed {
  font-family: $font-condensed;
}

.invitational {
  font-family: $font-invitational-nums;
}

</style>
